import { render, staticRenderFns } from "./AgendarServico.vue?vue&type=template&id=3ed58f28&"
import script from "./AgendarServico.vue?vue&type=script&lnag=ts&lang=js&"
export * from "./AgendarServico.vue?vue&type=script&lnag=ts&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports